// extracted by mini-css-extract-plugin
export default {"selectWrapper":"select-participant_selectWrapper__oyhGK"};